var redirectToUrl;
var loadedPersonalSuggestions;

function getLoginReturnUrl() {
    return encodeURIComponent(redirectToUrl ? redirectToUrl : window.location.hash);
}

/* SCRIPTS */
$(function ($) {
    const url = new URL(window.location.href);
    if (url.searchParams.has('IsSearchboxQuery')) {
        url.searchParams.delete('IsSearchboxQuery');
        history.replaceState({}, null, url.toString());
    }

    // Init hi module.
    $.hi = $.hi || {};

    // Validations

    // By default validator ignores hidden fields.
    // change the setting here to ignore nothing
    $.validator.setDefaults({ ignore: null });

    $.validator.addMethod('requiredforvalue', function (value, element, param) {
        var targetInput = $(param[0]);
        var currentValue = targetInput.is(':radio') ? targetInput.filter(':checked').val() : targetInput.val();
        var requiredForValue = param[2];

        if (currentValue === requiredForValue) {
            var val = $(element).val();
            return val && val.length > 0;
        }

        return true;
    });

    $.validator.unobtrusive.adapters.add('requiredforvalue', ['property', 'value'], function (options) {
        var $targetElement = $(options.form).find('#' + options.params.property);

        options.rules['requiredforvalue'] = [$targetElement[0], options.params.property, options.params.value];
        options.messages['requiredforvalue'] = options.message;
    });

    $.validator.addMethod("requiredif", function (value, element, param) {
        var $targetElement = $(`input[name=${param.propertyname}]`);
        const regex = new RegExp(element.dataset.valRequiredifPattern);

        var isRequired = $targetElement.is(':checkbox')
            ? $targetElement.is(':checked').toString() == param.propertyvalue
            : $targetElement.val().toLowerCase() == param.propertyvalue;

        const regexValid = element.dataset.valRequiredifPattern
            ? regex.test($.trim(value))
            : true;

        if (isRequired) {
            if (!this.depend(param, element))
                return "dependency-mismatch";
            switch (element.nodeName.toLowerCase()) {
                case 'select':
                    var val = $(element).val();
                    return val && val.length > 0;
                case 'input':
                    if (this.checkable(element))
                        return this.getLength(value, element) > 0 && regexValid;
                default:
                    return $.trim(value).length > 0 && regexValid;
            }
        }

        return true;
    });

    $.validator.unobtrusive.adapters.add("requiredif", ["property", "value"], function (options) {        
        options.rules["requiredif"] = {
            propertyname: options.params.property,
            propertyvalue: options.params.value
        };
        options.messages["requiredif"] = options.message;
    });

    $.validator.addMethod('requiredconsent', function (value, element, param) {
        var $element = $(element);

        if ($element.is(':checkbox')) {
            return $element.is(':checked');
        }

        return true;
    });

    $.validator.unobtrusive.adapters.add('requiredconsent', ['property', 'value'], function (options) {
        options.rules['requiredconsent'] = [];
        options.messages['requiredconsent'] = options.message;
    });

    $.validator.addMethod('rangeforvalue', function (value, element, params) {
        var targetInput = $(params[0]);
        var currentValue = targetInput.is(':radio') ? targetInput.filter(':checked').val() : targetInput.val();
        var rangeforvalue = params[2];
        var minValue = parseInt(element.dataset.valRangeforvalueMin);
        var maxValue = parseInt(element.dataset.valRangeforvalueMax);

        if (currentValue === rangeforvalue) {
            var val = parseInt($(element).val());
            return val && val >= minValue && val <= maxValue;
        }

        return true;
    });

    $.validator.unobtrusive.adapters.add('rangeforvalue', ['property', 'value'], function (options) {
        var $targetElement = $(options.form).find('#' + options.params.property);

        options.rules['rangeforvalue'] = [$targetElement[0], options.params.property, options.params.value];
        options.messages['rangeforvalue'] = options.message;
    });
}(jQuery));

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;

        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function showFlashMessage(message, isError) {
    const color = isError ? 'error' : 'success';
    $('.js-flash-message-container').html(`<div class="o-flash-message o-flash-message--visible o-flash-message--${color}">${message}</div>`);
}

function copyUrl(url) {
    if (!url) {
        url = `${$(location).attr('origin')}${$(location).attr('pathname')}`;
    }

    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(url).select();
    document.execCommand("copy");
    $temp.remove();
}

$(document).ready(function () {
    // Things to hide on click

    $('body').click(function (e) {
        var $clickedElement = $(e.target);
        if ($clickedElement.hasClass('js-search-item')) {
            return;
        }

        if ($clickedElement.closest('.js-search-item').length) {
            return;
        }

        closeFullTextSearch();
    });

    // popup close on escape

    $('body').keydown(function (e) {
        if (e.keyCode == 27 && $('.c-new-ad__step-1--visible').length > 0) {
            $('.js-step-1').removeClass('c-new-ad__step-1--visible');
            $('body').removeClass('u-no-scroll');
        }
        else if (e.keyCode == 27 && $('.c-user-popup--visible').length > 0) {
            $('.js-user-popup').removeClass('c-user-popup--visible');
            $('body').removeClass('u-no-scroll');
            loginOpen = false;
        }
        else if (e.keyCode == 27 && $('.c-filter-popup--visible').length > 0) {
            $('.js-filters-container').removeClass('c-filter-popup--visible');
            $('body').removeClass('u-no-scroll');
        }
        else if (e.keyCode == 27 && $('.c-message-popup--visible').length > 0) {
            $('.js-message-popup').removeClass('c-message-popup--visible');
            $('body').removeClass('u-no-scroll');
        }
        else if (e.keyCode == 27 && $('.c-new-ad__step-3--visible').length > 0) {
            $('.js-step-3').removeClass('c-new-ad__step-3--visible');
            $('body').removeClass('u-no-scroll');
        }
        else if (e.keyCode == 27 && $('.c-popup--visible').length > 0) {
            $('.c-popup').removeClass('c-popup--visible');
            $('body').removeClass('u-no-scroll');
        }
    });

    // Menu scrolling

    var lastScrollTop = 0;

    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop && st > 100) {
            $('.js-header-compact').addClass('c-header-compact--hidden');
            $('.js-side-bar').removeClass('c-main__side-bar--scrolling-top');
            $('.js-side-banners').removeClass('c-main__banners--scrolling-top');
        } else {
            $('.js-header-compact').removeClass('c-header-compact--hidden');
            $('.js-side-bar').addClass('c-main__side-bar--scrolling-top');
            $('.js-side-banners').addClass('c-main__banners--scrolling-top');
            $('#adfContainer').removeClass('scrolling');
        }

        if (st > lastScrollTop) {
            $('#adfContainer').addClass('scrolling');
        } else {
            $('#adfContainer').removeClass('scrolling');
        }
        lastScrollTop = st;
    });


    $(window).bind('load', function () {

        var bannerTimer = setInterval(bannerTime, 500);
        var bannerTimerinterator = 0;

        function bannerTime() {
            if ($('#adfContainer').length > 0) {
                $('.js-banner-leader-main').removeClass('c-banner__leaderboard--no-padding');
                $('.c-desktop-search').removeClass('c-desktop-search--no-banner');
                $('.c-header-compact__placeholder').removeClass('.c-header-compact__placeholder--bg');
                $('.c-header__placeholder').removeClass('.c-header__placeholder--bg');
                clearInterval(bannerTimer);
            }

            else {
                $('.js-banner-leader-main').addClass('c-banner__leaderboard--no-padding');
                $('.c-desktop-search').addClass('c-desktop-search--no-banner');
                $('.c-header-compact__placeholder').addClass('.c-header-compact__placeholder--bg');
                $('.c-header__placeholder').addClass('.c-header__placeholder--bg');
            }

            if (bannerTimerinterator >= 4) {
                clearInterval(bannerTimer);
            }

            bannerTimerinterator++;
        }

        function stopBannerTime() {
            clearInterval(bannerTimer);
        }
    });



    // User menu

    $('.js-user-menu-switch').click(function (e) {
        e.stopPropagation();
        $('.js-user-menu').toggleClass('open');
    });

    // User list and article technical support

    $(document).on('click', '.js-user-list-switch', function (e) {
        e.preventDefault();
        $(this).siblings('.js-user-list-text').toggleClass('c-user-form__list-text--active');
        $(this).find('.js-user-list-image').toggleClass('c-user-form__list-image--active');
    });


    // Categories

    $(document).on('click', '.js-category-switch', function (e) {
        e.preventDefault();
        $('.js-categories').toggleClass('c-categories--active');
        $('.js-category-switch').toggleClass('js-category-switch--active');
    });

    $(document).on('click', '.js-continue-to-step-3', function (e) {
        e.preventDefault();
        $('.js-step-3').addClass('c-new-ad__step-3--visible');
        $('body').addClass('u-no-scroll');
    });

    function newAdPopup() {
        window.location.hash = "";

        $.ajax({
            url: "/inzeraty/NewStep1",
            success: function (html) {
                $("#js-popup-container").html(html);
                $('.js-step-1').addClass('c-new-ad__step-1--visible');
                $.validator.unobtrusive.parse("#new-ad-step1");
                loadCategoriesByParentId();
            },
            error: function (response) {
                if (response.status === 403) {
                    // We need to first set fragment to know where to return from login
                    window.location.hash = '#new-ad';
                    loginPopup();
                }
            }
        });
    }

    if (window.location.hash === "#new-ad") {
        newAdPopup();
    }

    $(document).on('click', '.js-add', function (e) {
        e.preventDefault();
        newAdPopup();
        window.dataLayer.push({
            'event': 'user-action',
            'category': 'Inzerat',
            'action': 'VlozeniBtn'
        });
    });

    $(document).on('click', '.js-close-step-1', function (e) {
        $('.js-step-1').removeClass('c-new-ad__step-1--visible');
        window.location.hash = '';
    });

    $(document).on('click', '.js-step-1', function (e) {
        window.dataLayer.push({
            'event': 'user-action',
            'category': 'Inzerat',
            'action': 'VlozeniPrvniKrok'
        });
    });

    /* USER POPUP */

    $(document).on('click', '.js-close-user-popup', function (e) {
        e.preventDefault();
        loginOpen = false;
        window.location.hash = '';
        $('.c-user-popup__container--active').removeClass('c-user-popup__container--active');
        $('.js-user-popup').removeClass('c-user-popup--visible');
    });


    // Textarea character counter

    var stringLength = 0;


    function charCounter(el) {
        var textareaValue = el.val();
        var maxlength = el.attr('maxlength');

        // Count new lines - js ignore new lines in text
        var numberOfLineBreaks = (textareaValue.match(/(\r\n|\n|\r)/g) || []).length;
        // Shortens the text according to the max length
        el.val(textareaValue.slice(0, maxlength - numberOfLineBreaks));
        // Rewrite value
        textareaValue = el.val();

        var stringLength = textareaValue.length + numberOfLineBreaks;

        var target = el.closest('.js-counter').find('.js-counter-target');
        target.html(stringLength);

        if (stringLength >= parseInt($('.js-counter-limit').html())) {
            target.addClass('o-counter__number--over');
        } else {
            target.removeClass('o-counter__number--over');
        }
    }

    $('.js-counter-source').each(function () {
        charCounter($(this));
    });

    $(document).on('keyup', '.js-counter-source', function (e) {
        charCounter($(this));
    });

    // Show password

    $(document).on('mousedown touchstart', '.js-show-password', function (e) {
        $('#' + $(this).attr('data-for')).attr('type', 'text');
    });

    $(document).on('mouseup mouseleave touchend', '.js-show-password', function () {
        $('#' + $(this).attr('data-for')).attr('type', 'password');
        $('#' + $(this).attr('data-for')).focus();
    });


    // CATEGORY SELECT

    var mq = window.matchMedia('(min-width: 1024px)');

    // DESKTOP

    let currentCategoryId = -1;
    let currentCategoryContent = '';

    function loadCategoriesByParentId(categoryId) {
        if (categoryId === currentCategoryId) {
            $('.js-category-select-container').html(currentCategoryContent);
            return;
        }

        $('.js-category-select-container').addClass('loading');

        $.ajax({
            url: '/inzeraty/Subcategories',
            data: {
                categoryId: categoryId
            },
            success: function (result) {
                $('.js-category-select-item-container').fadeIn();
                $('.js-category-select-container').html(result);
                $('.js-category-select-container').removeClass('loading');
                currentCategoryId = categoryId;
                currentCategoryContent = result;
            }
        });
    };

    let loadCategoriesByNameLastQuery = null;

    var loadCategoriesByName = debounce(function () {
        var query = $('#js-popup-container .js-category-select-input').val();
        if (loadCategoriesByNameLastQuery !== query) {
            $('#AdCategoryId').val(null);
        }
        loadCategoriesByNameLastQuery = query;

        if (query.length > 2) {
            $('.js-category-select-item-container').fadeIn();
            $('.js-category-select-container').addClass('loading');
            $('.js-category-select-change').hide();
            $('.js-category-select-input-container, .js-category-select-container, .js-category-select').addClass('open');

            var url = '/inzeraty/FindCategories?query=' + query;
            $.ajax({
                url: url,
                success: function (result) {
                    $(".js-category-select-container").html(result);
                    $('.js-category-select-container').removeClass('loading');

                    currentCategoryId = -1;
                },
                error: function () {
                    $('.js-category-select-container').removeClass('loading');

                    currentCategoryId = -1;
                }
            });
        } else {
            loadCategoriesByParentId();
        }
    }, 500);

    if (mq.matches) {
        $(document).on('click', '.js-category-select-switch, .js-category-select-change', function (e) {
            e.preventDefault();
            $('.js-category-select-input-container, .js-category-select-container').toggleClass('open');

            if ($('.js-category-select').hasClass('open')) {
                setTimeout(function () {
                    $('.js-category-select').toggleClass('open');
                    $('.js-category-select-change').toggle();
                }, 300);
            } else {
                loadCategoriesByParentId();

                $('.js-category-select').toggleClass('open');
                $('.js-category-select-change').toggle();
            }
        });
    }
    // MOBILE
    else {
        function openCategorySelector() {
            $('.js-category-select, .js-category-select-input-container, .js-category-select-container, .js-category-select-header').addClass('open');
            $('.js-category-select-switch').addClass('hidden');
            $('.js-category-select-search-button').addClass('visible');

            if ($('.js-category-select-container .js-select-category-item').length === 0) {
                loadCategoriesByName();
            }
        }

        $(document).on('click', '.js-category-select-input-container', openCategorySelector);
        $(document).on('focus', '.js-category-select-input', openCategorySelector);

        $(document).on('click', '.js-category-select-close', function () {
            $('.js-category-select, .js-category-select-input-container, .js-category-select-container, .js-category-select-header').removeClass('open');
            $('.js-category-select-switch').removeClass('hidden');
            $('.js-category-select-search-button').removeClass('visible');
        });

        $(document).on('click', '.js-category-select-search-button', function () {
            $('.js-category-select-container').addClass('loading');
            loadCategoriesByName();
        });
    }

    // DESKTOP & MOBILE UNIVERSAL

    $(document).on('keydown', '.js-category-select-input', function () {
        loadCategoriesByName();
    });

    $(document).on('click', '.js-category-back-button', function (e) {
        e.preventDefault();
        loadCategoriesByParentId($(this).data('parent-category-id'));
    });

    $(document).on('click', '.js-select-category-item', function (e) {
        e.preventDefault();

        if ($(this).hasClass('js-select-category-item-has-sub')) {
            loadCategoriesByParentId($(this).data('id'));
            $('.js-category-select-item-container').fadeIn();
        } else {
            loadCategoriesByNameLastQuery = $(this).attr('data-name');
            $('.js-category-select-input').val(loadCategoriesByNameLastQuery);
            $('.js-category-select-item-container').fadeOut();
            $('#AdCategoryId').val($(this).data('id'));
            $('#new-ad-step1').validate().form();
            $('.js-category-select, .js-category-select-input-container, .js-category-select-container, .js-category-select-header').removeClass('open');

            if (!mq.matches) {
                $('.js-category-select-switch').removeClass('hidden');
                $('.js-category-select-search-button').removeClass('visible');
            } else {
                $('.js-category-select-change').toggle();
            }
        }
    });

    // Fulltext search

    var searchItems = 0;
    var index = 0;

    var closeFullTextSearch = function () {
        selectedItem = 0;
        $('.js-search-results').removeClass('c-search-results--visible');
        $('.js-search-results').empty();
    };

    $(document).on('click', '.js-search-item', function (e) {
        e.preventDefault();
        e.stopPropagation();

        suggestionSelected($(this));
    });

    $('.js-search-area').click(function (e) {
        var $clickedElement = $(e.target);
        if (!($clickedElement.hasClass('js-search-item') || $clickedElement.parent('.js-search-item'))) {
            e.stopPropagation();
        }
    });

    $(document).on('submit', '.js-search-form', function (ev) {
        $(this).find('.js-data-submit-query').val(true);
    });

    var fullTextSearch = debounce(function (query) {
        if (query) {
            $('.js-search-area').addClass('loading');

            $.ajax({
                url: '/inzeraty/suggest',
                data: {
                    query: query
                },
                success: function (suggestions) {
                    var html = '';

                    var hasCategories = suggestions.categories.length > 0;
                    var hasTerms = suggestions.data.length > 0;

                    if (hasCategories) {
                        var items = suggestions.categories.map(function (c) {
                            return '<li class="c-search-results__list-item">' +
                                '  <a href = "' + c.url + '" class="c-search-results__item-link js-search-item js-search-category-item" >' +
                                '    <span class="c-search-results__item-icon">' +
                                '      <img src="' + c.image + '" alt="">' +
                                '    </span>' +
                                '  <span class="c-search-results__item-name">' + c.name + '</span>' +
                                '  </a>' +
                                '</li >';
                        }).join('');

                        var categories = '<div class="c-search-results__title">Kategorie</div>' +
                            '  <ul class="c-search-results__list">' +
                            items +
                            '  </ul>' +
                            '</div>';

                        html += categories;
                    }

                    if (hasTerms) {
                        var items = suggestions.data.map(function (t) {
                            return '<li class="c-search-results__list-item">' +
                                '  <a href="/inzeraty/index?query=' + t.name + '" class="c-search-results__item-link js-search-item" >' +
                                '    <span class="c-search-results__item-icon">' +
                                '      <img src="/img/icon_hledat_blue.svg" alt="">' +
                                '    </span>' +
                                '    <span class="c-search-results__item-name">' + t.name + '</span>' +
                                '  </a>' +
                                '</li>';
                        }).join('');

                        var terms = '<div class="c-search-results__title">Hledané výrazy</div>' +
                            '  <ul class="c-search-results__list">' +
                            items +
                            '  </ul>' +
                            '</div>';
                        html += terms;
                    }

                    $('.js-search-results').html(html);

                    searchItems = $('.js-desktop-search .js-search-item').length;

                    $('.js-search-area').removeClass('loading');

                    if (hasCategories || hasTerms) {
                        $('.js-search-results').addClass('c-search-results--visible');
                        $('.js-desktop-search .js-search-item').each(function (i) {
                            index = i + 1;
                            $(this).attr('id', 'search-item-' + index);
                        });
                    }
                    else {
                        $('.js-search-results').removeClass('c-search-results--visible');
                    }
                }
            })
        }
        else {
            closeFullTextSearch();
            $('.js-search-area').addClass('loading');
        }
    }, 500);

    function suggestionSelected($selectedItem) {
        var $form = $selectedItem.closest('form');
        var $searchInput = $form.find('.js-search-input');

        $searchInput.val($selectedItem.text().trim());

        if ($selectedItem.hasClass('js-search-category-item')) {
            var url = $selectedItem.attr('href');
            if (url != undefined && url != '') {
                if (url.indexOf('?') >= 0) {
                    url += '&'
                } else {
                    url += '?';
                }
                url += `IsSearchboxQuery=true`;

                if ($form.find('.js-nearby-search').is(':checked')) {
                    url += '&GeoLocation=' + $form.find('#GeoLocation').val() + '&DistanceSearch=true';
                }

                window.location.href = url;
            }
        }
        else if ($selectedItem.hasClass('js-search-query-item')) {
            var url = $selectedItem.attr('href');
            if (url != undefined && url != '') {
                let prefix = (url.indexOf('?') >= 0) ? '&' : '?';

                if ($form.find('.js-nearby-search').is(':checked')) {
                    url += prefix + 'GeoLocation=' + $form.find('#GeoLocation').val() + '&DistanceSearch=true';
                }

                window.location.href = url;
            }
        }
        else {
            $form.submit();
        }

        closeFullTextSearch();
    }

    $(document).on('keyup', '.js-search-input', function (e) {
        if (e.keyCode != 40 && e.keyCode != 39 && e.keyCode != 38 && e.keyCode != 37 && e.keyCode != 13 && e.keyCode != 27) {
            var query = $(this).val().trim();
            if (query.length > 2) {
                fullTextSearch(query);
            }
            else if (query.length == 0) {
                closeFullTextSearch();
            }
        }
    });

    function showQuerySuggestions(suggestions) {
        var html = '';

        var hasSuggestion = suggestions.length > 0;
        if (hasSuggestion) {
            var items = suggestions.map(function (c) {
                var url = (c.url ?? "/inzeraty/index") + c.query;
                var image = c.image ?? "/img/icon_hledat_blue.svg";
                return '<li class="c-search-results__list-item">' +
                    '  <a href = "' + url + '" class="c-search-results__item-link js-search-item js-search-query-item" >' +
                    '    <span class="c-search-results__item-icon">' +
                    '      <img src="' + image + '" alt="">' +
                    '    </span>' +
                    '  <span class="c-search-results__item-name">' + c.name + '</span>' +
                    '  </a>' +
                    '</li >';
            }).join('');

            var categories = '<div class="c-search-results__title">Naposledy hledané</div>' +
                '  <ul class="c-search-results__list">' +
                items +
                '  </ul>' +
                '</div>';

            html += categories;
        }

        $('.js-search-results').html(html);

        searchItems = $('.js-desktop-search .js-search-item').length;

        $('.js-search-area').removeClass('loading');

        if (hasSuggestion) {
            $('.js-search-results').addClass('c-search-results--visible');
            $('.js-desktop-search .js-search-item').each(function (i) {
                index = i + 1;
                $(this).attr('id', 'search-item-' + index);
            });
        }
        else {
            $('.js-search-results').removeClass('c-search-results--visible');
        }
    }

    var personalSuggestionLoader = debounce(function () {
        $.ajax({
            url: '/inzeraty/suggestpersonal',
            success: function (suggestion) {
                loadedPersonalSuggestions = suggestion;
                showQuerySuggestions(suggestion);

                // We load suggesion only once and cache it.
                personalSuggestionLoader = debounce(function () {
                    showQuerySuggestions(loadedPersonalSuggestions);
                }, 100);
            },
        });
    }, 100);

    $(document).on('focus', '.js-search-input', function (e) {
        var query = $(this).val().trim();
        if (query.length == 0) {
            $('.js-search-area').addClass('loading');
            personalSuggestionLoader();
        }
    });

    // Key navigation in menu

    var selectedItem = 0;

    $(document).keydown(function (e) {
        if ($('.c-search-results--visible').length > 0) {
            switch (e.keyCode) {
                case 40:
                    e.preventDefault();
                    selectedItem++;
                    $('.js-desktop-search .js-search-item').removeClass('c-search-results__item-link--active');
                    $('.js-desktop-search #search-item-' + selectedItem).addClass('c-search-results__item-link--active');
                    if (selectedItem >= searchItems) {
                        selectedItem = 0;
                    }
                    break;
                case 38:
                    e.preventDefault();
                    selectedItem--;
                    if (selectedItem <= 0) {
                        selectedItem = searchItems;
                    }
                    $('.js-desktop-search .js-search-item').removeClass('c-search-results__item-link--active');
                    $('.js-desktop-search #search-item-' + selectedItem).addClass('c-search-results__item-link--active');
                    break;
                case 13:
                    if (selectedItem >= 0 && selectedItem <= searchItems) {
                        e.preventDefault();

                        var $selectedItem = $('#search-item-' + selectedItem);
                        suggestionSelected($selectedItem);

                    } else {
                        $('.js-search-all').trigger('click');
                    }
                    break;
                case 27:
                    e.preventDefault();
                    closeFullTextSearch();
            }
        }
    });

    var loginOpen = false;

    function loginPopup() {
        if (loginOpen == false) {
            loginOpen = true;
            $.ajax({
                url: `/Users/Login?returnUrl=${getLoginReturnUrl()}`,
                success: function (html) {
                    $('.js-log-in').removeClass('c-header__button--account-loading');
                    $('#js-popup-container').html('<div class="c-user-popup js-user-popup"></div>');
                    $('.js-user-popup').html(html);

                    $('.js-user-popup-login').addClass('c-user-popup__container--active');
                    $('.js-user-popup').addClass('c-user-popup--visible');
                }
            });
        }
    }

    function registerSocialPopup() {
        if (loginOpen == false) {
            loginOpen = true;
            $.ajax({
                url: `/Users/SocialRegistration?returnUrl=${getLoginReturnUrl()}`,
                success: function (html) {
                    $('.js-log-in').removeClass('c-header__button--account-loading');
                    $('#js-popup-container').html('<div class="c-user-popup js-user-popup"></div>');
                    $('.js-user-popup').html(html);

                    $('.js-user-popup-social-registration').addClass('c-user-popup__container--active');
                    $('.js-user-popup').addClass('c-user-popup--visible');
                }
            });
        }
    }

    if (window.location.hash.includes("#login")) {

        if (window.location.hash.includes("redirect")) {
            var redirectPath = window.location.hash.split("&redirect=")[1];
            redirectToUrl = `${redirectPath}`;
        }

        window.location.hash = "";
        loginPopup();
    }

    if (window.location.hash === "#socialregister") {
        window.location.hash = "";
        registerSocialPopup();
    }

    // 'Back' button
    $(document).on('click', '.js-registration-back, .js-lost-password-back', function (e) {
        loginOpen = false;
        loginPopup();
    });

    // Log in

    $(document).on('click', '.js-log-in', function (e) {
        $(this).addClass('c-header__button--account-loading');
        e.preventDefault();
        loginPopup();
    });

    // Show login popup if user is not logged in and clicks on button that requires logged user
    $(document).on('click', '.js-logged-in-only', function (e) {
        if ($('.js-log-in').length) {
            e.preventDefault();
            // We need to first set redirect to know where to return from social login
            redirectToUrl = e.target.href;
            $('.js-log-in').trigger('click');
        }
    });

    // FAQ

    $(document).on('click', '.js-faq-title', function(){
        $(this).toggleClass('c-faq__item-title--active');
        $(this).next('.js-faq-item').toggleClass('c-faq__item--visible');
    });

    // Favourite

    $(document).on('click', '.js-favourite-ad', function (e) {
        e.preventDefault();
        e.stopPropagation();
        favourite($(this));
        $(this).addClass('loading');
    });

    function favourite($adCard) {
        debounce(function () {
            if ($('.js-log-in').length) {
                $('.js-log-in').trigger('click');
                $adCard.removeClass('loading');
                return;
            }
            var identifier = $adCard.attr('data-identifier');
            var data = { identifier: identifier }

            if ($adCard.hasClass('active')) {
                $.ajax({
                    method: 'POST',
                    url: '/inzeraty/AdUnfavourite',
                    data: data,
                    success: function () {
                        $adCard.removeClass('active');
                        $adCard.removeClass('loading');
                        $adCard.title = 'Přidat do oblíbených.';
                    },
                    error: function (response) {
                        if (response.status == 401) {
                            $('.js-log-in').trigger('click');
                        }
                        $adCard.removeClass('loading');
                    }
                });
            }
            else {
                $.ajax({
                    method: 'POST',
                    url: '/inzeraty/AdFavourite',
                    data: data,
                    success: function () {
                        $adCard.addClass('active');
                        $adCard.removeClass('loading');
                        $adCard.title = 'Odebrat z oblíbených.';
                    },
                    error: function (response) {
                        if (response.status == 401) {
                            $('.js-log-in').trigger('click');
                        }
                        $adCard.removeClass('loading');
                    }
                });
            }
        }, 500)();
    }

    //18+ popup
    $(document).on('click', '.js-close-warning-popup', function (e) {
        e.preventDefault();
        $.ajax({
            url: '/Users/GrantIsAdultConsent',
            success: function () {
                $('.js-warning-popup').removeClass('c-popup--visible');
                location.reload();
            }
        });
    });

    // New ad topping tooltips
    $(document).on('click', '.js-new-ad-tooltip-switch', function (e) {
        e.preventDefault();
        $('.js-new-ad-tooltip-target').removeClass('c-new-ad__label-tooltip--visible');
        $(this).next('.js-new-ad-tooltip-target').toggleClass('c-new-ad__label-tooltip--visible');
    });

    $(document).on('click', '.js-new-ad-tooltip-target', function (e) {
        e.preventDefault();
        $(this).removeClass('c-new-ad__label-tooltip--visible');
    });

    // Phone number input

    $.hi.initPhoneNumberInput = function ($element) {
        var $container = $element || $(document);
        $container.find('.js-phone-number-input').mask('+^^_ ^^^ ^^^ ^^^', {
            translation: {
                '_': { pattern: /[0-9]/, optional: true },
                '^': { pattern: /[0-9]/ },
                '0': { pattern: '0', fallback: '0' }
            }
        });
    };

    $.hi.initPhoneNumberInput();

    $(document).on('focus', '.js-phone-number-input', function () {
        var $phoneNumber = $(this);

        if (!$phoneNumber.prop('readonly') && !$phoneNumber.val()) {
            $phoneNumber.val('+420');
        }
    });

    $(document).on('blur', '.js-phone-number-input', function () {
        var $phoneNumber = $(this);

        if ($phoneNumber.val() === '+420') {
            $phoneNumber.val('');
        }
    });

    // Click on whole ad item links to ad detail

    $(document).on('click', '.js-ad-list-link', function (e) {
        const url = window.location.href.split('#', 2)[0];
        const id = $(this).attr('id');
        history.replaceState(history.state, document.title, `${url}#${id}`)
        window.location.href = $(this).data('link');
    });

    // Click to partner link to stop opening the ad detail.
    // Stop bubbling phases.
    $(document).on('click', '.js-partner-link', function (e) {
        e.stopPropagation();
    });

    // User indicator for mobile a desktop version

    let indicators = $('.js-message-indicator');
    $.each(indicators,
        function (key, value) {
            let indicator = $(value);
            let messageCount = parseInt(indicator.data('count'));

            if (messageCount >= 10) {
                indicator.html('9+');
            }

            indicator.addClass('c-header__indicator--visible');
    });

    // Copy to clipboard

    $(document).on('click', '.js-copy-to-clipboard', function(){
        var text = $(this).html();
        var input = document.createElement('textarea');
        input.innerHTML = text;
        document.body.appendChild(input);
        input.select();
        var result = document.execCommand('copy');
        document.body.removeChild(input);
        return result;
    });

    // Watchdog Popup

    $(document).on('click', '.js-toggle-watch-dog-popup', function(){
        $('.js-watchdog-popup').toggleClass('c-watch-dog-popup--visible');
    });

    // Watchdog create/update disable button on submit
    $(document).on('submit', '#js-watchdog-form', function () {
        $(this).find("button[type='submit']").prop('disabled', true);
    });

    // Point list toggle

    $(document).on('click', '.js-point-list-toggle', function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('c-ad-list__point-text--active');
        $(this).parent().next('.js-point-list-target').toggleClass('c-ad-list__point-item-container--visible');
    });

    $(document).on('input', '.js-points-range, .js-points-target', function(){
        var value = $(this).val();
        var numberValue = Number(value);
        var valueText = numberValue == 1 ? ' bod' : numberValue > 1 && numberValue < 5 ? ' body' : ' bodů';
        $('.js-points-target, .js-points-range').val(value);
        $('.js-slider-bubble-points').text(value);
        $('.js-slider-bubble-points-text, .c-new-ad__slider-number-text').text(valueText);
        setBubble(document.querySelector('.js-points-range'), document.querySelector('.js-slider-bubble'));
    });

    function setBubble(range, bubble) {
        const val = range.value;
        const min = range.min ? range.min : 0;
        const max = range.max ? range.max : 100;
        const newVal = Number(((val - min) * 100) / (max - min));

        // Sorta magic numbers based on size of the native UI thumb
        bubble.style.left = `calc(${newVal}% + (${1 - newVal * 0.15}px))`;
    }

    setBubble(document.querySelector('.js-points-range'), document.querySelector('.js-slider-bubble'));
});